import React, { type ChangeEvent } from "react";
import { AutoComplete, Button, Form, type FormInstance } from "antd";
import CodeEditor from "@uiw/react-textarea-code-editor";

type ValidateStatus = Parameters<typeof Form.Item>[0]["validateStatus"];

interface SendCommandFormProps {
  form: FormInstance;
  onFinish: (values: any) => void;
  onFinishFailed: (errorInfo: any) => void;
  params: {
    value: string;
    validateStatus?: ValidateStatus;
    errorMsg?: string | null;
  };
  onMethodFiedlsChange: (value: string) => void;
  onParamsChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  methods: any[];
  confirmButton?: boolean;
  canUserEdit?: boolean;
}

function SendCommandForm({
  form,
  onFinish,
  onFinishFailed,
  params,
  onMethodFiedlsChange: onMethodFielsChange,
  onParamsChange,
  methods,
  confirmButton = true,
  canUserEdit = false,
}: SendCommandFormProps): JSX.Element {
  return (
    <Form
      layout="vertical"
      name="basic"
      form={form}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <Form.Item
        label="Метод"
        name="method"
        rules={[{ required: true, message: "Введите название метода" }]}
      >
        <AutoComplete
          options={methods}
          onChange={onMethodFielsChange}
          placeholder="Введите метод"
          filterOption={(inputValue, option) =>
            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }
        />
      </Form.Item>

      <Form.Item
        label="Параметры"
        name="params"
        validateStatus={params.validateStatus}
        help={params.errorMsg ?? ""}
      >
        <CodeEditor
          language="yaml"
          placeholder="Заполните параметры метода"
          padding={15}
          data-color-mode="light"
          style={{
            border: params.errorMsg != null ? "1px solid red" : "",
            borderRadius: "2px",
            fontSize: 14,
            backgroundColor: "white",
            fontFamily:
              "ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
          }}
          onChange={onParamsChange}
        />
      </Form.Item>

      {confirmButton && (
        <Form.Item>
          <Button disabled={!canUserEdit} type="primary" htmlType="submit">
            Отправить
          </Button>
        </Form.Item>
      )}
    </Form>
  );
}

export default SendCommandForm;
